import { useAuth } from "../../contexts/AuthContext";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import "./index.css";
// import log_menu from "./assets/log-menu.png";
/* import usuario from './assets/usuario.png' */
// import modo_dia from "./assets/modoo-dia.png";
// import modo_noche from "./assets/modo-noche.png";
// import logo_color from "../../assets/logo_colors.png";
import menu from "./assets/list.svg";
import watch from "./assets/stopwatch-fill.svg";
import React from "react";
import { CustomDialog } from "../../components/Dialog";
import { useTheme } from "../../contexts/ThemeContext";
import { SenceValidation } from "../../services/sence";
import { useTimer } from "../Timer";
// import { THEME_CONTEXT } from "../../utils/theme";
import { LIMIT_CRON_AVG } from "../../utils/state";
import { Snackbar } from "../../components/Snackbar";
import { DEFAULT_SNACKBAR, SENCE_WARNING } from "../../utils/snackbar";
import LogoutIcon from "@mui/icons-material/Logout";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { IconButton } from "@mui/material";
import { useMoodleV2 } from "../../contexts/moodle";
import { useConfig } from "../../contexts/config";
import { Sidebar } from "../Sidebar";
import { darken, readableColor } from "polished";
import { DuelBadge } from "./DuelBadge";
import { createLogger } from "../../utils/debug";
import { usePageAlignment } from "./usePageAlignment";

const log = createLogger("Navbar");

/* to work on */
export const Navbar = ({ layout: propsLayout, handleContentLayout: propsHandleContentLayout }) => {
  const { time, limit } = useTimer();
  const auth = useAuth();
  const { lang } = useAuth();
  const { config } = useConfig();
  const theme = useTheme();
  const navref = React.useRef(null);
  usePageAlignment(navref, lang);
  const isSence = localStorage.getItem("sence_session");
  const [snackbar, setSnackbar] = React.useState(DEFAULT_SNACKBAR);
  const [open, setOpen] = React.useState(false);
  // const icon = theme.mode === "light" ? modo_dia : modo_noche;
  // const [sidebar, toggleSidebar] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const moodlev2 = useMoodleV2();

  const layout = propsLayout !== undefined ? propsLayout : moodlev2?.courseLayout;
  const handleContentLayout = propsHandleContentLayout || moodlev2?.toggleCourseLayout;

  React.useEffect(() => {
    log.success(`tab activa: ${location.pathname}`);
  }, [location.pathname]);

    const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [isScrolled, setIsScrolled] = React.useState(false);

    const toggleDrawer = (isOpen) => {
      setDrawerOpen(isOpen);
    };

  React.useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  React.useEffect(() => {
    if (limit > LIMIT_CRON_AVG) {
      handleSenceLogout();
      localStorage.removeItem("last_login_sence");
      localStorage.removeItem("sence_session");
      localStorage.removeItem("current_course");
      localStorage.removeItem("idSence");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time]);

 /*  React.useEffect(() => {
    lang && console.log(lang["Navbar"]);
  }, [lang]); */

  const handleLogout = () => {
    setOpen(true);
  };
  const handleLogoutCompleted = async () => {
    setOpen(false);
    localStorage.removeItem("sence_validated");
    // auth.logout ya navega (redirect a WordPress) cuando hay wpUrl; solo
    // navegamos aquí si devuelve false, es decir si no tomó el control.
    if (!(await auth.logout(moodlev2, { redirigirExterno: true }))) navigate("/");
  };

  const handleDarkMode = () => {
    theme.actions.handleDarkMode();
  };

  const handleSenceLogout = () => {
    let id = localStorage.getItem("idSence");
    if (!id) {
      return;
    }
    let sence = JSON.parse(localStorage.getItem("sence_session"));
    let nru = localStorage.getItem("nru");
    let validation = {
      idSence: id,
      auth,
      session: sence,
      isLogin: false,
      nru,
    };
    /*     console.log(sence) */
    localStorage.removeItem("sence_validated"); // ! por ahora se asume que sencevalidation para cerrar sesión es exitoso, por lo que se borra el flag. pero esto es temporal por la urgencia.
    SenceValidation(validation);
  };

  let disabled = {
    pointerEvents: isSence ? "none" : "",
    opacity: isSence ? 0.5 : 1,
  };

  let timer = null;

/*   const handleSenceWarning = () => {
    if (!isSence) {
      return;
    }
    if (timer != null) {
      clearTimeout(timer);
      timer = null;
      return;
    } else {
      timer = setTimeout(closeSenceWarning, 2000);
      setSnackbar(SENCE_WARNING);
      return;
    }
  }; */

/*   const closeSenceWarning = () => {
    setTimeout(() => {
      setSnackbar(DEFAULT_SNACKBAR);
    }, 2000);
  };
 */
  // const handleSidebar = () => {
  //   let { style } = document.querySelector(".sidebar-container");
  //   if (!sidebar) {
  //     style.left = "0";
  //     return toggleSidebar(!sidebar);
  //   }

  //   style.left = "-350px";
  //   toggleSidebar(!sidebar);
  // };

  return (
    <>
      {lang && (
        <nav ref={navref} className={`app-main-navbar h-[82px] transition-all duration-300 ${isScrolled ? 'bg-[#282A37]/80 backdrop-blur-md ' : 'bg-transparent'}`}>
          <div
            className="nav_block"
/*             onMouseEnter={handleSenceWarning}
            onMouseLeave={handleSenceWarning} */
          >
            <div className="logo">
              <img
                alt="img"
                src={
                  config.theme && (theme && theme.mode === "light" ? config.theme.logo : config.theme.theme_logo_dark)
                }
                style={{ maxHeight: "70px", width: "auto", objectFit: "contain",padding: "5px", cursor: "pointer" }}
                onClick={() => navigate("/listcourses")}
              />
            </div>
            <div className="list">
              <ul className="navlist" datatoggle="tooltip">
                <NavLink to={"/listcourses"} end data-page-alignment-anchor style={disabled} onClick={() => log.info("click en tab: /listcourses")}>
                  {({ isActive }) => (
                    <li
                      className="list-item"
                      style={{ color: isActive ? "#ECB236" : theme.colors.textColorNavbar, textDecoration: isActive ? "underline" : "none", fontWeight: 700 }}
                    >
                      {lang["Navbar"].home}
                    </li>
                  )}
                </NavLink>
                <NavLink to={"/listcourses/progress"} style={disabled} onClick={() => log.info("click en tab: /listcourses/progress")}>
                  {({ isActive }) => (
                    <li
                      className="list-item"
                      style={{ color: isActive ? "#ECB236" : theme.colors.textColorNavbar, textDecoration: isActive ? "underline" : "none",fontWeight: 700 }}
                    >
                      {lang["Navbar"].history}
                    </li>
                  )}
                </NavLink>
                {/*               <li className='list-item'>Malla</li>
              <li className='list-item'>DNC</li> */}
                <NavLink to={"/estudio"} style={disabled} onClick={() => log.info("click en tab: /estudio")}>
                      {({ isActive }) => (
                        <li
                          className="list-item"
                          style={{ color: isActive ? "#ECB236" : theme.colors.textColorNavbar, textDecoration: isActive ? "underline" : "none", fontWeight: 700 }}
                        >
                          Estudio
                        </li>
                      )}
                    </NavLink>
                    <NavLink to={"/foro"} style={disabled} onClick={() => log.info("click en tab: /foro")}>
                  {({ isActive }) => (
                    <li
                      className="list-item"
                      style={{ color: isActive ? "#ECB236" : theme.colors.textColorNavbar, textDecoration: isActive ? "underline" : "none", fontWeight: 700 }}
                    >
                      Foro
                    </li>
                  )}
                </NavLink>
                {config.opciones.includes("contacto") && (
                  <NavLink to={"/contact"} style={disabled} onClick={() => log.info("click en tab: /contact")}>
                    {({ isActive }) => (
                      <li
                        className="list-item"
                        style={{ color: isActive ? "#ECB236" : theme.colors.textColorNavbar, textDecoration: isActive ? "underline" : "none", fontWeight: 700 }}
                      >
                        {lang["Navbar"].contact}
                      </li>
                    )}
                  </NavLink>
                )}
              </ul>
            </div>
          </div>
          <div className="nav_block">
            <div className="row menu">
              <div className="col-3 col-md-3">
                <img
                  src={menu}
                  alt="..."
                  className="burger size-12 max-w-[unset]"
                  onClick={() => toggleDrawer(true)}
                />
              </div>
            </div>
            {isSence && (
              <div
                className="student_profile stopwatch"
                style={{
                  cursor: "pointer",
                  justifyContent: "space-between",
                  //backgroundColor: THEME_CONTEXT.DAY_MODE_BTN,
                  borderRadius: "10px",
                  margin: "10px",
                  padding: "7px 10px",
                  backgroundColor:theme.mode === "light" ? theme.colors.button_light :  theme.colors.button_dark ,
                }}
                onClick={handleSenceLogout}
              >
                <img src={watch} alt="..." />
                <p style={{color:theme.mode === "light" ? readableColor(darken(0.2,theme.colors.backgroundColorNavBar)) :  readableColor(theme.colors.backgroundColorNavBar)}} className="font-semibold text-2xl p-2 rounded-md">{time}</p>
                <p className="font-semibold text-2xl p-2 rounded-md" style={{backgroundColor:
                    theme.mode === "light"
                      ? theme.colors.tertiary_light
                      : theme.colors.primary_light,color:theme.mode === "light" ? readableColor(darken(0.2,theme.colors.backgroundColorNavBar)) :  readableColor(theme.colors.backgroundColorNavBar)}}>Cerrar Sesión Sence</p>
              </div>
            )}

            {window.location.pathname.includes("detailcourse") && (
              <div
                className="student_profile menu-handler-button"
                style={{
                  margin: 0,
                  transform: layout ? "rotate(180deg)" : "rotate(0deg)",
                  backgroundColor:
                    theme.mode === "light"
                      ? theme.colors.tertiary_light
                      : "rgb(236, 178, 54)",
                }}
              >
                <IconButton
                  onClick={handleContentLayout}
                  sx={{ padding: "5px" }}
                >
                  {layout ? (
                    // <KeyboardArrowRightIcon
                    //   sx={{
                    //     color: theme.mode === "light" ? "#fff" : "#fff",
                    //     fontSize: 30,
                    //   }}
                    // />
                    <MenuOpenIcon
                      sx={{
                        color: theme.mode === "light" ? "#fff" : "rgb(101, 72, 1)",
                        fontSize: 35,
                      }}
                    />
                  ) : (
                    // <KeyboardArrowLeftIcon
                    //   sx={{
                    //     color: theme.mode === "light" ? "#fff" : "#fff",
                    //     fontSize: 30,
                    //   }}
                    // />
                    <MenuOpenIcon
                      sx={{
                        color: theme.mode === "light" ? "#fff" : "#fff",
                        fontSize: 35,
                      }}
                    />
                  )}
                </IconButton>
              </div>
            )}

            <DuelBadge
              token={auth?.token || localStorage.getItem("token")}
              currentUserId={auth?.user?.id}
            />
            <div
              className="student_profile"
              style={{ cursor: "pointer", transition: "opacity 0.2s" }}
              onClick={() => navigate("/mi-cuenta")}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
            >
              <div style={{ textAlign: "right" }}>
                <p style={{ color: theme.colors.textColorNavbar, fontWeight: 700, fontSize: "var(--font-size-body, 16px)" }}>
                  {auth && auth.user?.fullname}
                </p>
                <p style={{ color: theme.colors.textColorNavbar, fontSize: "var(--font-size-min, 15px)", opacity: 0.85 }}>
                  Mi cuenta
                </p>
              </div>
              <img
                alt="img"
                src={auth.user?.profileimageurlsmall}
                style={{ borderRadius: "50%" }}
              />
            </div>

            {/* <div
              className="modo_dia"
              onClick={handleDarkMode}
              style={{
                backgroundColor: theme.mode === "light" ? "#f5f5f5" : "#333",
              }}
            >
              {theme.mode === "light" ? (
                <>
                  <LightModeIcon sx={{ fontSize: 22, fill: "#2d4662" }} />
                </>
              ) : (
                <DarkModeIcon sx={{ fontSize: 22 }} />
              )}
            </div> */}
            <div className="logout" onClick={handleLogout}>
              <LogoutIcon
                sx={{
                  fontSize: 30,
                  color: theme.colors.textColorNavbar,
                }}
              />
            </div>
          </div>
          <Snackbar
            message={snackbar.message}
            severity={snackbar.severity}
            visible={snackbar.visible}
          />
          <CustomDialog
            open={open}
            message={lang["Snackbars"].acc_logout_message}
            confirm={lang["Snackbars"].confirm}
            cancel={lang["Snackbars"].cancel}
            sence={isSence}
            onCancel={() => setOpen(false)}
            onConfirm={handleLogoutCompleted}
          />

          <Sidebar isOpen={drawerOpen} onClose={() => toggleDrawer(false)} />
        </nav>
      )}
    </>
  );
};
